import { createSelector } from 'reselect';

export const getUtterances = ({ intentUtterances }) =>
  intentUtterances.list.data;

export const getIsLoading = ({ intentUtterances }) =>
  intentUtterances.list.isLoading;

export const getIsAdding = ({ intentUtterances }) =>
  intentUtterances.add.isLoading;

export const getIsUpdating = ({ intentUtterances }) =>
  intentUtterances.update.isLoading;

export const getIsDeleting = ({ intentUtterances }) =>
  intentUtterances.delete.isLoading;

export const getUtterancesIds = createSelector(getUtterances, utterances =>
  utterances.map(({ id }) => id),
);

export const getDeletedUtterances = utterances =>
  createSelector(getUtterances, oldUtterances => {
    const newUtterancesIds = utterances.map(({ id }) => id);

    return oldUtterances.filter(({ id }) => !newUtterancesIds.includes(id));
  });

export const getAddedUtterances = utterances =>
  createSelector(getUtterancesIds, oldUtterancesIds =>
    utterances.filter(({ id }) => !oldUtterancesIds.includes(id)),
  );
